import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { RootParams } from '@ftr/api-shared'

@Component({
  selector: 'ftr-mfa-recover-account-page',
  template: '<ftr-mfa-recover-account [returnUrl]="returnUrl" />',
  standalone: false,
})
export class MfaRecoverAccountPage implements OnInit {
  returnUrl: string

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.returnUrl = this.route.snapshot.queryParams[RootParams.ReturnUrl]
  }
}
